import useSWR from "swr";
import { ModelTokens, ThreadCost } from "@/models/agent/threadCost";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";

export const useThreadCosts = (threadId: string | null) => {
  const fetcher = async () => {
    if (!threadId) return null;
    return await AgentService.getThreadCosts(threadId);
  };

  const { data, error, isLoading, mutate } = useSWR(
    threadId ? ["agent", "threadCosts", threadId] : null,
    fetcher,
    defaultSWROption,
  );

  const cost = data
    ? Object.entries(data.costs_by_model)
      .reduce<Record<string, ModelTokens>>((acc, [modelName, tokens]) => {
        acc[modelName] = {
          inputTokens: tokens.total_input_tokens,
          outputTokens: tokens.total_output_tokens,
          cachedInputTokens: tokens.total_cached_input_tokens,
          cacheCreationTokens: tokens.total_cache_creation_tokens,
        };
        return acc;
      }, {})
    : null;

  return {
    threadCost: new ThreadCost(cost || {}),
    error,
    isLoading,
    mutate,
  };
};
